var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergyEfficiency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.45 49.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e48f25;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.72,0A24.73,24.73,0,1,1,0,24.72,24.73,24.73,0,0,1,24.72,0Zm0,4.22a20.5,20.5,0,1,0,20.5,20.5A20.5,20.5,0,0,0,24.72,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.78,19a1.68,1.68,0,0,0-2.07-1.17L17.84,21.39a1.69,1.69,0,0,0-1.17,2.07,1.67,1.67,0,0,0,1.59,1.22s0,.05.08.06l0,0A4.72,4.72,0,0,1,21,27.15H24.1a6.61,6.61,0,0,0-1.94-3.46l9.45-2.6A1.69,1.69,0,0,0,32.78,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.33,28.78H19.67a1,1,0,0,0-1,1v4.45a1,1,0,0,0,1,1,6.88,6.88,0,0,0,1.87.68V39a1,1,0,0,0,1,1h1a1,1,0,0,0,.85.5h1.22a1,1,0,0,0,.85-.5h1a1,1,0,0,0,1-1V35.91a6.88,6.88,0,0,0,1.87-.68,1,1,0,0,0,1-1V29.78A1,1,0,0,0,30.33,28.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.26,
    y: 14.11,
    width: 14.93,
    height: 3.36,
    rx: 1.59,
    transform: "translate(-3.3 7.13) rotate(-15.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.07,8.56a6.41,6.41,0,0,0-6.18,4.7L29.5,10.34A6.39,6.39,0,0,0,25.07,8.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.21,22.11c-1.62.87-3.56,1.92-4.31,5H29a4.72,4.72,0,0,1,2.61-2.39l0,0a1.48,1.48,0,0,0,.6-2A1.52,1.52,0,0,0,30.21,22.11Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyEfficiency);
export default __webpack_public_path__ + "static/media/energy-efficiency.7b27128d309568ae06d1d564d03acf26.svg";
export { ForwardRef as ReactComponent };